export const getStockChartContainerId = (id: number) => `oms-stock-chart-${id}`;

export const getStockChartTopMenuId = (id: number) =>
  `oms-stock-chart-bottom-menu${id}`;

export const getStockChartBottomMenuId = (id: number) =>
  `oms-stock-chart-bottom-menu${id}`;
